// SPEC: https://docs.google.com/document/d/1SPo_wFnMlJ8cofEBYDJtwFwig1765a8ERtR4Yi8dBU8/edit?ts=57614f64


define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var lpBaseService = require('web-agent-services/BaseService');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var APPLICATION_TYPE = 'lpMessagingEngagementsHistoryService';
    var TIMEOUT = 10000;
    var BASE = lpBaseService;

    var lpMessagingEngagementsHistoryService = function lpMessagingEngagementsHistoryService() {
        BASE.call(this, {
            serviceName: getServiceName()
        });
        this._initializeApiResource();
    };

    lpUtils.extend(lpMessagingEngagementsHistoryService, BASE);

    lpMessagingEngagementsHistoryService.prototype = new lpBaseService();

    lpMessagingEngagementsHistoryService.prototype.applicationType = APPLICATION_TYPE;

    lpMessagingEngagementsHistoryService.prototype._initializeApiResource = function () {
        // validate configuration and resource lookup:
        if (!this.apiResourceService) {
            return this.logger.error('cannot create end points for the service, no service end point.');
        }

        // this should be corresponding with the apiResources.json file.
        this.apiEndPoints = {
            SearchEngagements: this.createAPIEndPointService('SearchEngagements'),
            SearchEngagementsByAgent: this.createAPIEndPointService('SearchEngagementsByAgent'),
            SearchEngagementsByConsumer: this.createAPIEndPointService('SearchEngagementsByConsumer'),
            SearchEngagementsByConversation: this.createAPIEndPointService('SearchEngagementsByConversation'),
            photoSharingGetUrl:this.createAPIEndPointService('photoSharingGetUrl')
        };
    };

    lpMessagingEngagementsHistoryService.prototype._search = function (callingFunction, reqObj, endPoint) {
        reqObj.callingFunction = callingFunction;
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.additionalUrl = this.apiEndPoints[endPoint].additionalUrl;
        if (lpTag.WebAgent.logicController.getMessagingSdesSiteSetting()) {
            reqObj.query = reqObj.query || {};
            reqObj.query.v = "2";
        }
        if (reqObj.pollingCallback) {
            this.apiEndPoints[endPoint].startPolling(reqObj);
            // this is important, it's let the invoker to stop the polling by demand.
            return this.apiEndPoints[endPoint].stopPolling.bind(this);
        } else {
            this.apiEndPoints[endPoint].stopPolling();
            this.apiEndPoints[endPoint].sendRequest(reqObj);
        }
    };

    lpMessagingEngagementsHistoryService.prototype.searchEngagements = function searchEngagements(reqObj, endPoint) {
        return this._search('searchEngagements', reqObj, endPoint);
    };


    lpMessagingEngagementsHistoryService.prototype.searchEngagementsByConsumer = function searchEngagementsByConsumer(reqObj) {
        reqObj.callingFunction = 'searchEngagements';
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.additionalUrl = this.apiEndPoints.SearchEngagementsByConsumer.additionalUrl;

        this.apiEndPoints.SearchEngagementsByConsumer.sendRequest(reqObj);
    };

    lpMessagingEngagementsHistoryService.prototype.searchEngagementsByConversation = function SearchEngagementsByConversation(reqObj) {
        reqObj.callingFunction = 'searchEngagements';
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.additionalUrl = this.apiEndPoints.SearchEngagementsByConversation.additionalUrl;
        this.apiEndPoints.searchEngagementsByConversation.sendRequest(reqObj);
    };


    lpMessagingEngagementsHistoryService.prototype.photoSharingGetUrl = function photoSharingGetUrl(reqObj) {
        reqObj.method = 'POST';
        reqObj.timeout = TIMEOUT;
        reqObj.additionalUrl = this.apiEndPoints.photoSharingGetUrl.additionalUrl;
        this.apiEndPoints.photoSharingGetUrl.sendRequest(reqObj);
    };

    function getServiceName() {
        return agentLEManager.getCSDSRecord('msgHist') ? "MessagingEngagementsHistory" : "MessagingEngagementsHistoryOnSharedServers";
    }


    return lpMessagingEngagementsHistoryService;

});
